// @ts-nocheck
import { logoutAction } from "../../store/actions/auth";
import { ALERT_DIALOG } from "../../store/constants/auth";
import { SETUP_EMAIL_REDIRECTION_PATH } from "../../store/constants/emailRedirectionConstants";
import { store } from "../../store/store";

const storeEmailRedirectionContext = (locationParams, navigate) => {
  // NOTE: redirection for sms consent contractor
  // const consentData = urlParams?.get("smsConsentData");
  // if (consentData) {
  //   const userId = urlParams?.get("userId");
  //   if (userId) {
  //     navigate("sms-consent", {
  //       state: {
  //         userId,
  //         smsConsentData: JSON.parse(atob(consentData)),
  //       },
  //     });
  //     return;
  //   }
  // }

  if (!locationParams?.includes?.("email=true")) {
    return null;
  }

  const data = locationParams?.includes("data=")
    ? decodeURIComponent(
        locationParams?.split?.("data=")?.[1]?.split?.("&")?.[0],
      )
        ?.replaceAll?.("'", "")
        ?.replaceAll("|", " ")
    : null;
  const tabString = decodeURIComponent(
    locationParams?.split?.("tab=")?.[1]?.split?.("&")?.[0],
  )?.replaceAll?.("'", "");
  const tab = Number(tabString);
  const redirectionRoute = decodeURIComponent(
    locationParams?.split?.("redirect=")?.[1]?.split?.("&")?.[0],
  )?.replaceAll?.("'", "");
  let redirectionPath = redirectionRoute + (tab >= 0 ? `?tab=${tab}` : "");

  let parsedData = data
    ? JSON.parse(!data?.startsWith("{") ? atob(data) : data)
    : null;

  const userId = locationParams?.split?.("userId=")?.[1]?.split?.("&")?.[0];

  if (!store?.getState()?.auth?.userToken) {
    if (
      locationParams?.includes?.("email=true") &&
      locationParams?.includes?.("redirect")
    ) {
      store.dispatch({
        type: SETUP_EMAIL_REDIRECTION_PATH,
        payload: {
          path: redirectionPath,
          data: parsedData,
          user: userId,
        },
      });

      if (redirectionPath == "/contractor-invite") {
        navigate(redirectionPath, {
          state: parsedData,
        });
        return;
      }
      navigate("/login");
    }
  } else {
    if (!userId) {
      navigate(redirectionPath, {
        state: parsedData,
      });
      return;
    }

    if (userId === store?.getState?.()?.auth?.userId) {
      navigate(redirectionPath, {
        state: parsedData,
      });
    } else {
      store.dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: "Error!",
          message:
            "The link is not for this user. Logout from this account and login with the correct email.",
          onOk: () => {
            store.dispatch({
              type: SETUP_EMAIL_REDIRECTION_PATH,
              payload: {
                path: redirectionPath,
                data: parsedData,
              },
            });
            store.dispatch(
              logoutAction({
                whitelistedReducers: ["emailRedirection"],
              }),
            );
            navigate("/login");
          },
          okLabel: "Logout",
        },
      });
    }
  }

  return null;
};

const getEmailData = (locationParams, navigate) => {
  const data = decodeURIComponent(
    locationParams?.split?.("data=")?.[1]?.split?.("&")?.[0],
  )?.replaceAll?.("'", "");

  let parsedData = JSON.parse(data || null);

  if (parsedData) {
    return parsedData;
  } else {
    return null;
  }
};

export default storeEmailRedirectionContext;
export { getEmailData };